import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { logout } from '../actions/AutenticacaoActions';



const Header = props => {
	let history = useHistory();
	const [count, setCount] = useState(25);

	useEffect(() => {
		if(!props.connection) {
			const timer = window.setInterval( _=> {
				if(!count) {
					if(window.navigator.onLine)
						document.location.reload(true);
					else
						setCount(25)
				} else {
					setCount(count - 1)
				} 
				
			}, 1000);

			return () => {
				window.clearInterval(timer);
			};

		}
		
	}, [props.connection, count]);


	function reload() {
		if(window.navigator.onLine)
			document.location.reload(true);
		else
			setCount(25)
	}

	function handleClickProfile() {
		history.push("/profile");
	}
	function handleClickDashboard() {
		history.push("/supervision/dashboard");
	}
	function handleClickAgents() {
		history.push("/supervision/agents");
	}

	function handleClickQueues() {
		history.push("/supervision/queues");
	}

	async function handleClickMonitor() {
		let server = await localStorage.getItem('server')
		var url = server.replace(/[0-9]/g, '');

		window.open(`${url}/monitoramento.php`)
	}

	function handleClickHome() {
		history.push("/");
	}

	function renderButtomSupervision() {
		if(props.employee==='supervisor') {
			return (
				<>
					<NavDropdown title="Supervisão" id="collasible-nav-dropdown">
							
						<NavDropdown.Item onClick={handleClickDashboard}>
							<i className="fa fa-fw fa-dashboard"></i> {'  '}
							Dashboard
						</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item onClick={handleClickAgents}>
							<i className="fa fa-fw fa-users"></i> {'  '}
							Agente(s)
						</NavDropdown.Item>
						<NavDropdown.Divider />
						<NavDropdown.Item onClick={handleClickQueues}>
							<i className="fa fa-fw fa-bars"></i> {'  '}
							Fila(s)
						</NavDropdown.Item>
						<NavDropdown.Divider />
						{/* <NavDropdown.Item onClick={handleClickQueues}>
							<i className="fa fa-fw fa-archive"></i> {'  '}
							Relátorio(s)
						</NavDropdown.Item> */}
						<NavDropdown.Divider />
						<NavDropdown.Item onClick={handleClickMonitor}>
							<i className="fa fa-fw fa-desktop"></i> {'  '}
							Monitor
						</NavDropdown.Item>						
					</NavDropdown>
				</>
			)
		}

		return false;
	}

	function handleNetwork() {
		if(!props.connection) {
			return (
				<div class="alert alert-warning text-center" role="alert" style={{ marginBottom:"0px" }}>
					<strong>
						<span class="glyphicon glyphicon-warning-sign"></span>
						Aguardando pela conexão com o servidor, 
					</strong>
					tentando novamente em {count} segundos...

					<a href="javascript:void(0)" onClick={reload} class="alert-link">Tentar agora</a>
				</div>
			)
		}
		return false;
	}
	
	return (
		<>
			{ handleNetwork() }
			<Navbar collapseOnSelect expand="lg" style={{  backgroundColor: '#3c8dbc' }} variant="dark">
				<Navbar.Brand >
					{/* <img src="/assets/images/logo_vtcall.png" style={{marginTop:"-10px"}} /> */}
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="mr-auto">
						<Nav.Link onClick={handleClickHome}>Atendimento</Nav.Link>

						{ renderButtomSupervision() }
					</Nav>
					<Nav>
						<NavDropdown title={props.name.toUpperCase()} id="collasible-nav-dropdown">

							<NavDropdown.Item onClick={handleClickProfile}>
							<i className="fa fa-fw fa-user"></i> {'  '}
								Perfil
							</NavDropdown.Item>

							<NavDropdown.Divider />
							<NavDropdown.Item onClick={props.logout}>
								<i className="fa fa-fw fa-power-off"></i> {'  '}
								Sair
							</NavDropdown.Item>
						</NavDropdown>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</>
	)
};

const mapStateToProps = state => {
    return ({
        employee: state.AutenticacaoReducer.employee,
        name: state.AutenticacaoReducer.name,
        connection: state.AplicationReducer.connection,
	})
}
  
export default connect(mapStateToProps, { logout })(Header);